import { Component } from '@angular/core';
import { DataService } from '../data.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-events',
  imports: [CommonModule],
  templateUrl: './events.component.html',
  styleUrl: './events.component.scss'
})
export class EventsComponent {
  events: any[] = [];
  loading = false;
  errorMessage: string | null = null;

  constructor(private dataService: DataService, private router: Router) {
    this.getEvents();
  }

  selectEvent(item: any) {
    this.router.navigate(['/', item.event_id]);
  }

  getEvents() {
    this.loading = true;
    this.errorMessage = null;
    this.dataService.fetchEvents().subscribe({
      next: (response: any) => {
        this.loading = false;
        console.log('Events fetched:', response.data);
        if (response.data) {
          this.events = response.data;
        }
      },
      error: (error: Error) => {
        this.loading = false;
        this.errorMessage = error.message;
        console.error('Error fetching events:', error);
      },
      complete: () => {
        console.log('Events fetching completed');
      }
    });
  }
}
